var processInclude = require('base/util');

$(document).ready(function() {
    processInclude(require('./components/simpleVideoVimeoControl.js'));
    processInclude(require('./components/fullScreenVideoVimeoControl.js'));
    processInclude(require('./components/carousel.js'));
    processInclude(require('./components/navigationBar.js'));
    processInclude(require('./components/expandingTextSectionControl.js'));
    processInclude(require('./components/reflectionVideoControl.js'));
    processInclude(require('./components/shareModalControl.js'));
    processInclude(require('./components/videoBackgroundHeroBanner.js'));
    processInclude(require('./components/collapsibleMobileGrid3r3cControl.js'));
    processInclude(require('./components/leverJobApiLookup.js'));
    processInclude(require('./components/leverJobsApiLookup.js'));
    processInclude(require('./components/videoModalControl.js'));
    processInclude(require('./components/carouselContentHub.js'));
});